<template>
  <div>
    <van-skeleton title animate :row="12" :round="true" :loading="loading_ske">
      <div class="tag01">
        用户标签
        <Icon type="ios-redo" size="25" class="auth01" @click="back"/>
      </div>
      <div class="tag02 tag04">
        <el-select
          v-model="value"
          multiple
          filterable
          remote
          reserve-keyword
          class="tag06"
          placeholder="请输入关键词（查询所有标签请输入‘所有’）"
          :remote-method="remoteMethod"
          :loading="loading">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" round class="tag05" @click="addLabel">添加标签</el-button>
      </div>
      <div class="tag03">
        <el-tag
          :key="index"
          v-for="(item,index) in list"
          closable
          :disable-transitions="false"
          @close="handleClose(item,index)">
          {{item.lableName}}
        </el-tag>
      </div>
    </van-skeleton>
  </div>
</template>

<script>
  var me;
  var user;
  var menu;
  import httpLab from '@/api/label';
  import util from "../../util/util";
  export default {
    name: "userLabel",
    data() {
      return {
        loading_ske:true,             //骨架屏显示
        options: [],
        list: [],
        loading: false,
        companyId: '',                //公司ID
        value:[],
        userId:'',                    //选中的用户ID
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
      menu = JSON.parse(sessionStorage.getItem('menu'));
      if (me.$route.params.hasOwnProperty('companyId')) {
        me.companyId = me.$route.params.companyId;
        me.userId = me.$route.params.userId;
      }
    },
    mounted() {
      let data = {
        mobile:user.mobile,
        sign:user.sign,
        userid:me.userId,
        companyid:me.companyId
      }
      httpLab.getUserLabel(data).then(res => {
        me.list = res.data.dataList;
        me.loading_ske = false;
      })
    },
    methods: {
      addLabel(){//添加标签
        let is_auth = util.is_Auth(menu,'用户管理','添加用户标签');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$Loading.start();
        if (me.value.length == 0) {
          me.$message.error('至少选择一个标签');
          return false;
        }
        let val = me.value.join(',');
        let datas = {
          mobile:user.mobile,
          sign:user.sign,
          companyid:me.companyId,
          userid:me.userId,
          lableIds:val
        }
        console.log(datas);
        httpLab.addUserLabel(datas).then(res => {
          switch (res.code) {
            case "0000":
              me.options = [];
              me.value = [];
              let data = {
                mobile:user.mobile,
                sign:user.sign,
                userid:me.userId,
                companyid:me.companyId
              }
              httpLab.getUserLabel(data).then(res => {
                me.list = res.data.dataList;
              })
              me.$message.success('添加成功');
              me.$Loading.finish();
              break;
            case "1111":
              me.$message.error('添加失败');
              me.$Loading.error();
              break;
          }
        })
      },
      remoteMethod(query) {
        if (query !== '') {
          me.loading = true;
          setTimeout(() => {
            if (query == '所有') {
              query = '';
            }
            let datas = {
              mobile:user.mobile,
              sign:user.sign,
              companyId:me.companyId,
              page:1,
              pageSize:200,
              kayword:query
            }
            console.log(datas);
            httpLab.labelList(datas).then(res => {
              me.options = res.data.dataList.map(item => {
                return { value: `${item.id}`, label: `${item.name}` };
              });
              console.log(me.options);
            })
            me.loading = false;
          }, 200);
        } else {
          this.options = [];
        }
      },
      handleClose(item,index) {
        let is_auth = util.is_Auth(menu,'用户管理','删除用户标签');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$confirm('此操作将删除该标签, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          me.$Loading.start();
          let data = {
            mobile:user.mobile,
            sign:user.sign,
            companyid:me.companyId,
            lableid:item.lableId,
            userid:me.userId
          };
          httpLab.delUserLabel(data).then(res => {
            console.log(res);
            switch (res.code) {
              case '0000':
                me.list.splice(index,1);
                me.$message.success('删除成功');
                me.$Loading.finish();
                break;
              case '1111':
                me.$message.error('删除失败');
                me.$Loading.error();
                break;
            }
          })
        })
        // this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
      back(){
        var me = this;
        me.$router.push('/index/user/index');
      },
    }
  }
</script>

<style scoped>
  @import "../label/style.css";
</style>